// src/layout/Layout.js
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Layout.css';
import logoImage from '../logo_jrrobot.png';
import ClientSelector from '../components/ClientSelector'; 

const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  
  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Função para determinar se é admin
  const isAdmin = () => {
    return user?.isAdmin === true || user?.role === 'admin';
  };

  

  // Menus para usuário padrão
  const standardMenuItems = [
    { path: '/dashboard', icon: '📋', text: 'Dashboard de Casos' },
    { path: '/gestao-casos', icon: '⚖️', text: 'Gestão de Casos' },
    { path: '/pesquisa-jurisprudencia', icon: '🔎', text: 'Pesquisa Jurisprudência' },
    { path: '/gerar-documentos', icon: '✨', text: 'Gerar Documentos' },
    { path: '/meus-documentos', icon: '📁', text: 'Meus Documentos' },
    { path: '/conferir-documento', icon: '✅', text: 'Conferir Documento' },
    { path: '/calculo-honorarios', icon: '💰', text: 'Cálculo de Honorários' },
    { path: '/workflows', icon: '🤖', text: 'Agentes JRRobot' },
    // Aberta a todos: cada um vê as auditorias que criou. O âmbito é imposto
    // no servidor (auditoriaPropria + filtro nas listagens), não aqui.
    { path: '/auditorias', icon: '🔍', text: 'Auditoria de Processos' },
    { path: '/chat-with-ai', icon: '💬', text: 'Chat com a IA' },
    { path: '/clientdata', icon: '👤', text: 'Dados do Cliente' },
    { path: '/estatisticas', icon: '📊', text: 'Estatísticas de Uso' }
  ];

  // ✅ Admin menu (com item de ação)
  const adminMenuItems = [
    { path: '/dashboard', icon: '📋', text: 'Dashboard de Casos' },
    { path: '/gestao-casos', icon: '⚖️', text: 'Gestão de Casos' },
    { path: '/pesquisa-jurisprudencia', icon: '🔎', text: 'Pesquisa Jurisprudência' },
    { path: '/gerar-documentos', icon: '✨', text: 'Gerar Documentos' },
    { path: '/meus-documentos', icon: '📁', text: 'Meus Documentos' },
    { path: '/conferir-documento', icon: '✅', text: 'Conferir Documento' },
    { path: '/calculo-honorarios', icon: '💰', text: 'Cálculo de Honorários' },
    { path: '/workflows', icon: '⚙️', text: 'Workflows' },
    { path: '/auditorias', icon: '🔍', text: 'Auditoria de Processos' },
    { path: '/chat-with-ai', icon: '💬', text: 'Chat com a IA' },
    { path: '/clientdata', icon: '👤', text: 'Dados do Cliente' },
    { path: '/estatisticas', icon: '📊', text: 'Estatísticas de Uso' },


    { path: '/usuarios', icon: '🧑‍💼', text: 'Gerenciar Usuários' }
  ];

  const menuItems = isAdmin() ? adminMenuItems : standardMenuItems;

  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <div className="logo">
            <img src={logoImage} alt="JR Robot Logo" className="logo-image" />
            <h1>Jaime Roriz Robot</h1>
          </div>

          {/* ✅ NOVO: Seletor de Cliente no Centro */}
          <div className="header-center">
            <ClientSelector />
          </div>

          <div className="user-menu">
            <span className="user-greeting">
              Olá, {user?.name || 'Usuário'}
              {isAdmin() && <span className="admin-badge">Admin</span>}
            </span>
            <button className="logout-btn" onClick={handleLogout}>Sair</button>
          </div>
        </div>
      </header>

      <div className="content-wrapper">
        <nav className="sidebar">
          <ul className="nav-menu">
            {menuItems.map((item) => (
              <li key={item.path || item.id} className="nav-item">
                {item.type === 'action' ? (
                  <button
                    type="button"
                    className="nav-link"
                    onClick={item.onClick}
                    disabled={item.disabled}
                    style={{ width: '100%', textAlign: 'left' }}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.text}</span>
                  </button>
                ) : (
                  <NavLink
                    to={item.path}
                    className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}
                  >
                    <span className="nav-icon">{item.icon}</span>
                    <span className="nav-text">{item.text}</span>
                  </NavLink>
                )}
              </li>
            ))}
          </ul>

          <div className="user-type-indicator">
            <span className="user-type-text">
              {isAdmin() ? 'Usuário Administrador' : 'Usuário Padrão'}
            </span>
          </div>
        </nav>

        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
